import { CircularProgress } from "@mui/material";

export default function Loading({
  width = 40,
  height = 40,
  color = "#16BA81"
}) {
  return <CircularProgress color="primary" style={{ width, height, color }} />;
}
